import React from 'react';
import {LoadingOverlay} from "@mantine/core";

interface FullHeightLoadingOverlayProps {
    visible: boolean;
}

/**
 * Wraps Mantine's `LoadingOverlay` in a container sized to ~90% of the viewport height, centering it for full-page loading states.
 *
 * @param visible - Whether the overlay (and its container) should be rendered.
 */
const FullHeightLoadingOverlay = ({ visible }: FullHeightLoadingOverlayProps) => {
    return (
        <>
            {visible && (
                <div
                    style={{
                        textAlign: 'center',
                        marginTop: '50%',
                        width: '100%',
                        height: window.innerHeight * 0.9
                    }}
                >
                    <LoadingOverlay visible={visible} zIndex={1000} overlayProps={{ radius: "sm", blur: 2 }} />
                </div>
            )}
            {!visible && (
                <></>
            )}
        </>
    );
};

export default FullHeightLoadingOverlay;
